module.exports = __webpack_public_path__ + "img/tip-img.a226af23.png";